import { doc, getDoc, getFirestore, setDoc } from "@firebase/firestore";
import useSWR from "swr";
import { firebaseApp } from "../../../firebase/firebaseClient";
import { UserModule } from "../../../models/users";

const fetcher = async (url: string) => {
  if (url) {
    const splits = url.split(`/`);
    const user_id = splits[2];
    const module_id = splits[splits.length - 1];
    const firestore = getFirestore(firebaseApp);
    const userModuleRef = doc(
      firestore,
      "users",
      user_id,
      "learning_modules",
      module_id
    );

    let userModuleSnap = await getDoc(userModuleRef);
    let userModule;
    if (userModuleSnap.exists()) {
      userModule = userModuleSnap.data();
    } else {
      const newUserModule: UserModule = {
        user_id: user_id,
        module_id: module_id,
        total_sessions_duration: 0,
        number_of_sessions: 0,
        percentage_completed: 0,
        is_completed: false,
        is_in_progress: false,
        date_last_journal_entry: 0,
        module_values: [],
        stage_of_change: "",
        page_last_visited: "",
        started_journal_entries: false,
        date_completed: new Date().getTime(),
        date_created: new Date().getTime(),
        date_last_visited: new Date().getTime(),
      };
      await setDoc(userModuleRef, newUserModule);
      userModuleSnap = await getDoc(userModuleRef);
      userModule = userModuleSnap.data();
    }
    return userModule;
  } else {
    return undefined;
  }
};

function useUserLearningModule(user_id?: string, module_id?: string) {
  const { data, mutate, error } = useSWR(
    [
      user_id && module_id
        ? `/users/${user_id}/learning_modules/${module_id}`
        : null,
    ],
    fetcher
  );
  const result: {
    userModule: UserModule;
    isLoading: boolean;
    isError: boolean;
    mutate: any;
  } = {
    userModule: data as any,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
  return result;
}

export default useUserLearningModule;
